import { FC } from 'react';
import { coreClientBlocksApi } from '@cp/entities/blocks';
import { useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { SxProps } from '@cp/ds';
import { useBlockRender } from '../model/useBlockRender';

export const RenderRouteBlock: FC<{ blockName: string; sx?: SxProps }> = ({ blockName, sx }) => {
  const { routeId } = useClientWebRouteParams();
  const { data: blocks } = coreClientBlocksApi.endpoints.findPageBlocks.useQuery({ routeId: String(routeId!) });
  const [block] = (blocks || []).filter((item) => item && item.block.name === blockName);
  const { Render, props } = useBlockRender(block);

  if (!Render || !props) {
    return null;
  }

  return <Render sx={sx} {...props} />;
};
